import React from 'react';
import * as Sentry from '@sentry/react';

import BasePage from './LazyBasePage';
import withCookieHeaderHeight from '../components/withCookieHeaderHeight';
import ConnectedCityBrowseBaseScreen from '../SearchApp/containers/ConnectedCityBrowseBaseScreen';

import EnhancedSearchConsumerHeader from '../components/EnhancedSearchConsumerHeader';
import { getSearchPageHeaderOffset } from '../components/ConsumerHeader/utils';

import './BrowsePage.scss';

class BrowsePage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            headerOffset: getSearchPageHeaderOffset(props.cookieHeaderHeight),
        };
    }

    componentDidMount() {
        const { cookieHeaderHeight } = this.props;

        Sentry.setTag('sub_app', 'browse');

        this.setState({
            headerOffset: getSearchPageHeaderOffset(cookieHeaderHeight),
        });
    }

    componentDidUpdate(prevProps) {
        if (this.props.cookieHeaderHeight !== prevProps.cookieHeaderHeight) {
            this.setState({
                headerOffset: getSearchPageHeaderOffset(
                    this.props.cookieHeaderHeight,
                ),
            });
        }
    }

    render() {
        return (
            <BasePage
                {...this.props}
                structureHeader={EnhancedSearchConsumerHeader}
            >
                <div
                    className="feed-browse-page"
                    style={{ paddingTop: this.state.headerOffset }}
                >
                    <ConnectedCityBrowseBaseScreen {...this.props} />
                </div>
            </BasePage>
        );
    }
}

export default withCookieHeaderHeight(BrowsePage);
